<div class="ant-empty-image">
  <ng-container *ngIf="!isImageBuildIn">
    <ng-container *nzStringTemplateOutlet="nzNotFoundImage">
      <img [src]="nzNotFoundImage" [alt]="isContentString ? nzNotFoundContent : 'empty'" />
    </ng-container>
  </ng-container>
  <ui-empty-default *ngIf="isImageBuildIn && nzNotFoundImage !== 'simple'"></ui-empty-default>
  <ui-empty-simple *ngIf="isImageBuildIn && nzNotFoundImage === 'simple'"></ui-empty-simple>
</div>
<p class="ant-empty-description" *ngIf="nzNotFoundContent !== null">
  <ng-container *nzStringTemplateOutlet="nzNotFoundContent">
    {{ isContentString ? nzNotFoundContent : locale["description"] }}
  </ng-container>
</p>
<div class="ant-empty-footer" *ngIf="nzNotFoundFooter">
  <ng-container *nzStringTemplateOutlet="nzNotFoundFooter">
    {{ nzNotFoundFooter }}
  </ng-container>
</div>
